import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";

// Placeholder CookieSettings page for /cookie-settings route
function CookieSettings() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-black/90 text-white">
      <div className="bg-white text-black rounded-lg p-8 shadow-lg max-w-lg w-full">
        <h1 className="text-2xl font-bold mb-4">Cookie Settings</h1>
        <p className="mb-6">
          Here you can adjust your privacy and cookie preferences (demo page).
        </p>
        <p className="text-sm text-gray-600">This page is a placeholder. Implement settings as needed.</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cookie-settings" element={<CookieSettings />} />
      </Routes>
    </Router>
  );
}

export default App;
